import styled from 'styled-components/macro'
import { em, rgba } from '../../../utils/styles'

const FormInfo = styled.p`
  margin: 2em 0 .5em;
  font-size: ${em(16)};
  color: ${rgba('base', 0.4)};
`

export default FormInfo
